import { SuperModel } from './super-model.model';
import { Company } from './company.model';
import { Location } from './location.model';
import { User } from './user.model';
import { RoutePlan } from './route-plan.model';

export class Bus extends SuperModel {
  companyId: string;
  plate: string;
  company?: Company;
  location?: Location;
  driver?: User;
  dashboardLabel: string;
  numOfChildrenOnBoard: number;
  uniqueCode: string;
  activeRoutePlan?: RoutePlan | null;

  constructor(data: any = {}) {
    super(data);
    if (data.company) {
      this.company = new Company(data.company);
    }
    if (data.location) {
      this.location = new Location(data.location);
    }
    if (data.user) {
      this.driver = new User(data.location);
    }
    if (data.activeRoutePlan) {
      this.activeRoutePlan = new RoutePlan(data.activeRoutePlan);
    } else {
      this.activeRoutePlan = null;
    }
  }

  get isOnActiveRide(): boolean {
    return !!this.activeRoutePlan;
  }

  get serialised() {
    return {
      id: this.id,
      companyId: this.companyId,
      plate: this.plate,
      location: this.location && this.location.serialised,
      dashboardLabel: this.dashboardLabel,
      numOfChildrenOnBoard: this.numOfChildrenOnBoard,
      // company: this.company && this.company.serialised,
    };
  }
}
